import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

export default function DatePickerValue({ value, onChange, error }) {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker", "DatePicker"]}>
        <DatePicker
          label="Select date"
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              variant: "outlined",
              size: "small",
              fullWidth: true,
              sx: {
                borderRadius: "25px",
                backgroundColor: "none",
                input: {
                  fontFamily: "ADLaM Display",
                  color: "#6b6b6b",
                },
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
